import React, { Component } from 'react';
import moment from 'moment';
import _has from 'lodash/has';
import _get from 'lodash/get';
import Select from 'react-select';

import Subnav from '../subnav';

import AuthService from '../../state/auth.service';
import ConsultantDashboardEmptyPage from './ConsultantDashboardEmptyPage';
import EventCard from './EventCard';
import GroupApi from '../../api/group';
import OrganizationCard from './OrganizationCard';
import Checkbox from '../form/Checkbox';
import withEhsPageBehavior from '../../withEhsPageBehavior';

let lateEvents = [];
const SHOW_ARCHIVED_KEY = 'EHS.PCMH.SHOW_ARCHIVED_ORGANIZATIONS';

class ConsultantDashboardPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            organizations: [],
            events: [],
            consultants: [],
            isLoading: true,
            selectedConsultant: null,
            user: AuthService.getUser(),
            showArchivedOrganizations:
                JSON.parse(localStorage.getItem(SHOW_ARCHIVED_KEY)) || true,
        };
    }

    componentDidMount() {
        const groupId = this.state.user.group_id;
        this.setState({ isLoading: true }, () => {
            GroupApi.listOrganizationMetrics(groupId)
                .then((orgs) => {
                    this.setState({
                        organizations: orgs,
                        isLoading: false,
                    });

                    if (
                        this.state.user.resourceFiltered
                            .consultantRestricted !== true
                    ) {
                        GroupApi.getConsultancyTeamMembers(groupId).then(
                            (results) => {
                                let filteredData = this.filterConsultantsList(
                                    results
                                );

                                this.processConsultantsForSelectionMenu(
                                    filteredData
                                );
                            },
                            this
                        );
                    }
                })
                .catch((err) => {
                    this.setState({
                        isLoading: false,
                    });
                });
        });

        GroupApi.getEvents(groupId).then((events) => {
            this.setState({ events: events });
        });
    }

    processConsultantsForSelectionMenu(filteredData) {
        const consultants = filteredData.map((consultant, id) => {
            return {
                value: consultant.name,
                label: consultant.name,
                id,
                ...consultant,
            };
        });

        this.setState({ consultants }, () => {
            this.forceUpdate();
        });
    }

    filterConsultantsList = (results) => {
        let filtered = [];
        let initialOrgs = [];
        this.state.organizations.forEach(function (orgs) {
            initialOrgs.push(orgs.id);
        });

        for (let i = 0; i < results.length; i++) {
            const data = results[i];
            let hasAnyOrg = 0;

            if (
                _has(data, 'resourceFiltered.organizations') &&
                data.resourceFiltered.organizations &&
                data.resourceFiltered.consultantRestricted
            ) {
                const consultantOrgKeys = Object.keys(
                    data.resourceFiltered.organizations
                ).map(function (id) {
                    return parseInt(id, 10);
                });
                hasAnyOrg = initialOrgs.filter((value) =>
                    consultantOrgKeys.includes(value)
                );
            }

            if (hasAnyOrg.length) {
                let newData = { name: data.name, orgs: [] };
                const keys = Object.keys(data.resourceFiltered.organizations);
                for (const key of keys) {
                    newData.orgs.push(key);
                }
                filtered.push(newData);
            }
        }
        return filtered;
    };

    selectConsultantView = (consultant) => {
        this.setState({ selectedConsultant: consultant });
    };

    selectedConsultantBelongsToThisOrganization = (organizationId) => {
        // This function is for filtering the events and organizations in the consultant dashboard page.
        // We want to show only the organizations the selectedConsultant belongs to, and the events with these organizations.
        const { selectedConsultant, consultants } = this.state;

        // If All consultants or the selectedConsultant includes the organization id.
        try {
            let selectedConsultantBelongsToOrganization =
                selectedConsultant === null ||
                consultants[selectedConsultant.id].orgs.includes(
                    String(organizationId)
                );

            return selectedConsultantBelongsToOrganization;
        } catch (error) {
            return false;
        }
    };

    handleArchiveChange = (showArchivedOrgs) => {
        // Update the state.
        this.setState({ showArchivedOrganizations: showArchivedOrgs });

        // Update localStorage.
        localStorage.setItem(SHOW_ARCHIVED_KEY, showArchivedOrgs);
    };

    render() {
        const {
            organizations,
            isLoading,
            consultants,
            events,
            selectedConsultant,
        } = this.state;
        if (this.state.isLoading) {
            return (
                <div className="page">
                    <div className="page__subnav">
                        <Subnav />
                    </div>
                    <div className="page__body">
                        <i className="fa fa-circle-o-notch m2spin" />
                        Loading Organizations...
                    </div>
                </div>
            );
        }
        let hideButton = false;
        if (_has(this.state, 'user.resourceFiltered.consultantRestricted')) {
            hideButton = _get(
                this.state,
                'user.resourceFiltered.consultantRestricted'
            );
        }
        if (organizations.length < 1 && !isLoading) {
            return <ConsultantDashboardEmptyPage restricted={hideButton} />;
        }

        if (events) {
            // Get a list of events that are late.
            lateEvents = events.reduce((eventsList, evt) => {
                if (
                    this.selectedConsultantBelongsToThisOrganization(
                        evt.organization_id
                    ) &&
                    !evt.complete &&
                    moment(evt.date).isBefore(moment())
                ) {
                    let practice_names = [];
                    evt.practices.map((practice) => {
                        practice_names.push(practice.name + ', ');
                        return {}; // linter
                    });

                    eventsList.push(
                        <EventCard
                            isLate={true}
                            key={evt.id}
                            event={evt}
                            organizationName={evt.organization.name}
                            practiceName={practice_names}
                        />
                    );
                }
                return eventsList;
            }, []);
        }

        const displayedOrganizations = this.state.showArchivedOrganizations
            ? this.state.organizations
            : this.state.organizations.filter(
                  (organization) => !organization.is_archived
              );

        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav />
                </div>
                <div className="sidebarpage">
                    <div className="sidebarpage__content">
                        <h2> Organizations</h2>
                        <div className="consultant__filters">
                            <div className="consultant__filters-checkbox">
                                <Checkbox
                                    label="Show Archived Organizations"
                                    defaultChecked={
                                        this.state.showArchivedOrganizations
                                    }
                                    onChange={(value) =>
                                        this.handleArchiveChange(value)
                                    }
                                />
                            </div>
                            {this.state.user.resourceFiltered
                                .consultantRestricted !== true ? (
                                <div className="consultant__filters-container">
                                    <span>Filter By Consultant:</span>
                                    <div className="consultant__filters-select">
                                        <Select
                                            options={consultants}
                                            value={selectedConsultant}
                                            onChange={this.selectConsultantView}
                                            isClearable={true}
                                            searchable={false}
                                        />
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>

                        <div className="DashboardCards">
                            {displayedOrganizations.map((org) => {
                                if (
                                    this.selectedConsultantBelongsToThisOrganization(
                                        org.id
                                    )
                                ) {
                                    return (
                                        <OrganizationCard
                                            key={org.id}
                                            organization={org}
                                        />
                                    );
                                }
                                return '';
                            })}
                        </div>
                    </div>

                    <div className="sidebarpage__sidebar">
                        {lateEvents && lateEvents.length > 0 && (
                            <div>
                                <h2>Late Events</h2>
                                <div className="Sidebar">{lateEvents}</div>
                            </div>
                        )}

                        <h2>Upcoming Events</h2>
                        <div className="Sidebar">
                            {events.map((evt) => {
                                if (
                                    moment(evt.date).isAfter(moment()) &&
                                    this.selectedConsultantBelongsToThisOrganization(
                                        evt.organization_id
                                    )
                                ) {
                                    let practice_names = [];
                                    evt.practices.map((practice) => {
                                        practice_names.push(
                                            practice.name + ', '
                                        );
                                        return {}; // linter
                                    });
                                    return (
                                        <EventCard
                                            key={evt.id}
                                            event={evt}
                                            organizationName={
                                                evt.organization.name
                                            }
                                            practiceName={practice_names}
                                        />
                                    );
                                } else {
                                    return false;
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withEhsPageBehavior(ConsultantDashboardPage);
